const gallery = document.querySelector('.m-custom-galery');
const thumb = document.querySelector('.scroll-thumb');
const track = document.querySelector('.scroll-track');

function updateThumb() {
    const scrollLeft = gallery.scrollLeft;
    const scrollWidth = gallery.scrollWidth;
    const clientWidth = gallery.clientWidth;
    const trackWidth = track.clientWidth;
    
    // Thumb width in pixels based on visible portion
    const thumbWidth = (clientWidth / scrollWidth) * trackWidth;
    thumb.style.width = thumbWidth + 'px';
    
    // Maximum distance thumb can travel
    const maxTranslate = trackWidth - thumbWidth;
    
    // Thumb position in pixels
    const thumbPos = (scrollLeft / (scrollWidth - clientWidth)) * maxTranslate;
    thumb.style.transform = `translateX(${thumbPos}px)`;
}

gallery.addEventListener('scroll', updateThumb);
window.addEventListener('resize', updateThumb);
updateThumb();



document.addEventListener('DOMContentLoaded', (event) => {
    const countdownElement = document.querySelector('.morders-countdown');
   if(countdownElement){
    let countdownValue = Math.floor(Math.random() * (100 - 20 + 1)) + 20;
    countdownElement.textContent = countdownValue;
    function decreaseCountdown() {
        if (countdownValue > 0) {
            countdownValue--;
            countdownElement.textContent = countdownValue;
            countdownElement.classList.add('mfade');
            setTimeout(() => {
                countdownElement.classList.remove('mfade');
            }, 500);
        }
    }
    setInterval(decreaseCountdown, 5000);
}
});